import document from "./document"
import video from "./video"
import image from "./image"

export default {
  document,
  video,
  image
}